import { useState, useEffect, useCallback } from "react";
import type { ConfigMode } from "../Context/types";
import { ExistingProvider } from "../types";
import type { Provider } from "../../../../DealerAcquirersTable/types";
import { calculateAvailablePriorities } from "../utils/priorityCalculator";

export function usePriorityOptions(
  externalDealerProviders?: Provider[],
  mode?: ConfigMode,
  existingProvider?: ExistingProvider | null,
) {
  const [priorityOptions, setPriorityOptions] = useState<number[]>([]);

  const updatePriorities = useCallback(() => {
    const priorities = calculateAvailablePriorities(
      externalDealerProviders,
      mode,
      existingProvider,
    );
    setPriorityOptions(priorities);
  }, [externalDealerProviders, mode, existingProvider]);

  useEffect(() => {
    updatePriorities();
  }, [updatePriorities]);

  return priorityOptions;
}
